import React, { useState, useEffect } from "react";
import "../styles/quotation.css";

const Quotation = () => {
  const [loading, setLoading] = useState(false);

  const [popup, setPopup] = useState({
    show: false,
    type: "", // success | error
    message: "",
  });

  const [formData, setFormData] = useState({
    company: "",
    contactPerson: "",
    email: "",
    mobile: "",
    testingCategory: "",
    description: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      const res = await fetch("https://uas-2wis.onrender.com/api/quotation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success !== false) {
        setPopup({
          show: true,
          type: "success",
          message:
            "Thank you for your quotation request. Our technical team will contact you shortly.",
        });

        setFormData({
          company: "",
          contactPerson: "",
          email: "",
          mobile: "",
          testingCategory: "",
          description: "",
        });
      } else {
        setPopup({
          show: true,
          type: "error",
          message: "Something went wrong. Please try again later.",
        });
      }
    } catch {
      setPopup({
        show: true,
        type: "error",
        message: "Server error. Please try again after some time.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="quotation-page">
      {/* ===== HERO ===== */}
      <section className="quotation-hero">
        <div className="container">
          <span className="hero-tag">Official Request</span>
          <h1>Request a Quotation</h1>
          <p>
            Submit your testing requirements. Our technical team will review and
            respond with cost and schedule details.
          </p>
        </div>
      </section>

      {/* ===== FORM ===== */}
      <section className="quotation-form-section">
        <div className="container">
          <form className="quotation-form" onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label>Organisation / Company Name</label>
                <input
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Contact Person</label>
                <input
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

<div className="form-group">
  <label>Mobile Number</label>
  <input
    name="mobile"
    type="tel"
    inputMode="numeric"
    placeholder="10-digit mobile number"
    value={formData.mobile}
    maxLength="10"
    required
    onChange={(e) => {
      let value = e.target.value.replace(/\D/g, "");

      // mobile numbers
      if (value.length === 1 && !/[4-9]/.test(value)) {
        value = "";
      }

      setFormData({ ...formData, mobile: value });
    }}
  />
</div>


              <div className="form-group full">
                <label>Testing Category</label>
                <select
                  name="testingCategory"
                  value={formData.testingCategory}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Testing Category</option>
                  <option>Environmental Testing</option>
                  <option>Power Supply Variation Test Setup</option>
                  <option>EMI / EMC Test Setup</option>
                  <option>Mobile Ground Control Station</option>
                  <option>Universal Testing Machine</option>
                  <option>Standard Testing and Measurement</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="form-group full">
                <label>Brief Description of Requirement</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Provide brief details of system, component or testing requirement"
                  required
                />
              </div>
            </div>

            <button className="btn primary" disabled={loading}>
              {loading ? "Submitting..." : "Submit Quotation Request"}
            </button>
          </form>
        </div>
      </section>

      {/* ===== POPUP ===== */}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box ${popup.type}`}>
            <h2>
              {popup.type === "success"
                ? "Request Submitted"
                : "Submission Failed"}
            </h2>

            <p>{popup.message}</p>

            <button
              className="btn primary"
              onClick={() =>
                setPopup({ show: false, type: "", message: "" })
              }
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quotation;
